import React, { useState, useRef } from 'react';
import './App.css';

const bandMembers = [
  {
    name: 'Alpha Atari',
    role: 'Vocals, rhythm guitar, lead guitar, bass guitar, keyboards, harmonica'
  },
  {
    name: 'Xavier Photano',
    role: 'Vocals, rhythm guitar, lead guitar, bass guitar'
  },
  {
    name: 'Enya Hames',
    role: 'Vocals, rhythm guitar, bass guitar, keyboards, harmonica'
  },
  {
    name: 'Natalie Hames',
    role: 'Vocals, rhythm guitar, bass guitar, keyboards, harmonica, flute'
  },
  {
    name: 'Jean Hubbard',
    role: 'Drums, backup vocals'
  }
];

function App() {
  const [hasEntered, setHasEntered] = useState(false);
  const audioRef = useRef(null);

  const handleEnterSite = () => {
    setHasEntered(true);
    setTimeout(() => {
      if (audioRef.current) {
        audioRef.current.play().catch(err => console.log('Audio play failed:', err));
      }
    }, 100);
  };

  if (!hasEntered) {
    return (
      <>
        <style>{`
          html, body, #root {
            margin: 0;
            padding: 0;
            overflow: hidden;
          }
          .enter-screen {
            position: fixed !important;
            top: 0 !important;
            left: 0 !important;
            right: 0 !important;
            bottom: 0 !important;
            width: 100vw !important;
            height: 100vh !important;
            background: #000 !important;
            display: flex !important;
            align-items: center !important;
            justify-content: center !important;
            z-index: 999999 !important;
            overflow: hidden !important;
          }
        `}</style>
        <div className="enter-screen">
          <div style={{ textAlign: 'center' }}>
            <h1 style={{
              fontFamily: 'Cinzel, Georgia, serif',
              fontSize: '2.5rem',
              color: '#d4af37',
              marginBottom: '0.5rem',
              lineHeight: 1.2
            }}>Remember<br />The Snow Flowers</h1>
            <p style={{
              fontFamily: 'Cinzel, Georgia, serif',
              fontSize: '1.2rem',
              color: '#8b6d42',
              marginBottom: '2rem',
              fontStyle: 'italic'
            }}>- The Snow Flowerz</p>
            <button 
              onClick={handleEnterSite} 
              style={{
                fontFamily: 'Cinzel, Georgia, serif',
                fontSize: '1.2rem',
                fontWeight: 700,
                color: '#000',
                background: 'linear-gradient(135deg, #d4af37 0%, #f0d878 50%, #d4af37 100%)',
                border: 'none',
                padding: '1rem 3rem',
                borderRadius: '4px',
                cursor: 'pointer'
              }}
            >
              Enter
            </button>
          </div>
        </div>
        <audio ref={audioRef} src="/audio/2000_Years_in_the_Making.wav" loop={false} preload="auto" />
      </>
    );
  }

  return (
    <div className="app">
      {/* Background Audio (continues playing) */}
      <audio ref={audioRef} src="/audio/2000_Years_in_the_Making.wav" loop={false} autoPlay />

      {/* Hero Section */}
      <section className="hero">
        <div className="sacred-geometry"></div>
        <div className="hero-content">
          <h1 className="main-title">Remember<br /><span className="main-title-small">The Snow Flowers</span></h1>
          <p className="main-subtitle">- The Snow Flowerz</p>
          <p className="main-tagline">
            We are the energetic gateway by which you may perceive, listen to and enjoy the legendary and alleged 1960s-70s Anglo-American rock band known as<br /><strong className="tagline-band-name">"The Snow Flowers"</strong>
          </p>
          <div className="band-photo-container">
            <img 
              src="/band_interview.png" 
              alt="The Snow Flowers - Press Interview" 
              className="band-photo"
            />
            <div className="photo-grain"></div>
            <div className="photo-damage"></div>
          </div>
          <div className="mystical-star">
            <div className="star-core"></div>
            <div className="star-rays"></div>
            <div className="star-glow"></div>
            <div className="star-sparkles">
              <span></span><span></span><span></span><span></span>
              <span></span><span></span><span></span><span></span>
            </div>
          </div>
        </div>
      </section>

      {/* The Music CTA */}
      <section className="section music-cta">
        <div className="container">
          <img src="/discography.jpg" alt="The Snow Flowerz Complete Discography" className="discography-image" />
          <h3 className="discography-years">1967 - 1973</h3>
          <p className="music-cta-text">
            <strong>The Snow Flowerz</strong> - LISTEN NOW - Songs - Albums - Downloads - Discography - <a href="https://payhip.com/adamalchemy" target="_blank" rel="noopener noreferrer" className="click-here-btn">CLICK HERE</a>
          </p>
          <p className="music-cta-description">
            <strong>The Snow Flowerz</strong> have confirmed 6 studio albums (7 including their singles compilation album) which they claim represent <strong>The Snow Flowers</strong> entire catalog - beginning with the 1967 debut self-titled album - <strong>The Snow Flowers</strong> - and ending with their final 1973 album - Divine Design.
          </p>
          <p className="music-cta-description">
            Their music explored themes of faith, clairvoyance, esoteric wisdom, occultism, ancient mysticism, psychedelic revolution, Christian allegory, Jungian psychology, alchemical transmutation and spiritual conversion.
          </p>
        </div>
      </section>

      {/* The Five - Band Members */}
      <section id="albums-section" className="section band-section">
        <div className="container">
          <div className="mystical-star" style={{ marginTop: '0' }}>
            <div className="star-core"></div>
            <div className="star-rays"></div>
            <div className="star-glow"></div>
            <div className="star-sparkles">
              <span></span><span></span><span></span><span></span>
              <span></span><span></span><span></span><span></span>
            </div>
          </div>
          <h2 className="section-title" style={{ marginTop: '0.5rem' }}>The Five</h2>
          <p className="band-subtitle">Members of the World's<br />Most Controversial and Mysterious Band</p>
          
          <div className="band-members">
            {bandMembers.map((member, index) => {
              const memberPhotos = [
                '/alpha_atari.jpg',    // Alpha Atari
                '/member2.jpg',        // Xavier Photano
                '/enya_hames.jpg',     // Enya Hames
                '/natalie_hames.jpg',  // Natalie Hames
                '/jean_hubbard.jpg'    // Jean Hubbard
              ];
              const photoClasses = ['alpha-photo', 'xavier-photo', 'enya-photo', 'natalie-photo', 'jean-photo'];
              return (
                <div key={index} className="member-card">
                  {memberPhotos[index] ? (
                    <div className="member-photo-container">
                      <img 
                        src={memberPhotos[index]} 
                        alt={member.name}
                        className={`member-photo ${photoClasses[index]}`}
                      />
                      <div className="photo-grain"></div>
                      <div className="photo-damage"></div>
                    </div>
                  ) : (
                    <div className="member-photo-placeholder">
                      <div className="photo-static"></div>
                      <span className="photo-text">Photograph Lost to Time</span>
                    </div>
                  )}
                  <h3 className="member-name">{member.name}</h3>
                  <p className="member-role">{member.role}</p>
                </div>
              );
            })}
          </div>
          
          {/* Prominent Featured Artists */}
          <div className="featured-artists-section">
            <h3 className="featured-artists-title">Prominent Featured Artists</h3>
            <ul className="featured-artists-list">
              <li>Daniel Southern - <em>Producer</em></li>
              <li>Ernest Arland - <em>Former Snow Flower</em></li>
              <li>Martin Stanley - <em>Saxaphone Player</em></li>
              <li>Gilbert Jackson - <em>Singer/Songwriter</em></li>
              <li>London Symphony Orchestra</li>
              <li>Kate Hutchinson - <em>Singer</em></li>
              <li>Joshua Brown - <em>Singer</em></li>
              <li>Deryl Davidson - <em>Narrator</em></li>
              <li>Lester Harper - <em>Violinist/Cello Player</em></li>
              <li>St. Paul's Children's Choir</li>
              <li>Gabriel Winters - <em>Singer</em></li>
            </ul>
          </div>
          
          <div className="mystical-star featured-artists-star">
            <div className="star-core"></div>
            <div className="star-rays"></div>
            <div className="star-glow"></div>
            <div className="star-sparkles">
              <span></span><span></span><span></span><span></span>
              <span></span><span></span><span></span><span></span>
            </div>
          </div>
          
          {/* The Snow Flowers vs The Snow Flowerz */}
          <div className="lore-section">
            <h3 className="lore-title">The Snow Flowers<br/><span className="lore-vs">v.s</span><br/>The Snow Flowerz</h3>
            <div className="lore-text">
              <p>The Snow Flowerz are believed most prominently to be a work of fiction based around an equally fictional band that is alleged to have been active from 1967 to 1973 under the name "The Snow Flowers."</p>
              <p>While there is no evidence nor any public records suggesting that the band ever existed, the music undoubtedly speaks for itself, and while it has been confirmed to (at least partially) be A.I generated, the mythical backdrop of lore that embellishes the quality of work is undeniably captivating, elaborate and mysterious, leading some to believe that the music, photo/video archives and lore behind "The Snow Flowerz" are channeled messages and interpretations that embody the essential energy, spirit and vibrational signature of an actual 1960s-70s band called The Snow Flowers who may have existed on a different timeline, or perhaps in a different dimension/parallel reality.</p>
              <p>Even the name "The Snow Flowerz," with a "z" rather than an "s" is supposedly used in order to emphasize the idea that they (The Snow Flowerz) are merely the vehicle by which our world may perceive, observe or witness The Snow Flowers, but just as a TV channel broadcasts images that represent (and closely resemble) the reality of people, places and things, it nevertheless remains true that the channel is not the actual person, place or thing.</p>
            </div>
          </div>
          
          {/* Coming Soon Section */}
          <div className="mystical-star" style={{ marginTop: '-2rem' }}>
            <div className="star-core"></div>
            <div className="star-rays"></div>
            <div className="star-glow"></div>
            <div className="star-sparkles">
              <span></span><span></span><span></span><span></span>
              <span></span><span></span><span></span><span></span>
            </div>
          </div>
          <h3 className="coming-soon-title">
            Merch Store and Photo Video Archives <span className="coming-soon-red">COMING SOON</span>
          </h3>
          
          {/* Behind the Music Section */}
          <div className="mystical-star" style={{ marginTop: '2rem' }}>
            <div className="star-core"></div>
            <div className="star-rays"></div>
            <div className="star-glow"></div>
            <div className="star-sparkles">
              <span></span><span></span><span></span><span></span>
              <span></span><span></span><span></span><span></span>
            </div>
          </div>
          <h3 className="behind-music-title">
            <span className="behind-music-bold">Behind the Music</span>
          </h3>
          <p className="behind-music-subtitle"><em>History and Band Lore</em></p>
        </div>
      </section>

      {/* Formation Section */}
      <section className="section formation-section">
        <div className="container">
          <h3 className="formation-title">Formation - Debut Album - Tribute to Ernest Arland</h3>
          <img src="/formation_cover.jpg" alt="Formation Album Cover" className="formation-cover" />
          <p className="photo-caption">The Snow Flowers - 1967 Debut Album</p>
          <div className="formation-text">
            <p>Little is known definitively regarding the circumstances leading up to the band's conception, but it is said that both David Winslow (Alpha Atari) and Alexander Dunsworth (Xavier Photano) immigrated to the United States in 1965 (from the UK) and are believed to have met Ernest Arland, Jean Hubbard and the Hames sisters late in the year while the 4 were yet part of the San Francisco gospel rock group known as "The Whimsical Sisters."</p>
            <p>The Snow Flowers were thereby officially formed in San Francisco around May of 1966, roughly 7 months before the death of Ernest Arland, who was regarded (by all 5 surviving members) as the band's founder, and who was killed by a drunk driver on December 12, 1966.</p>
          </div>
          <img src="/ernest_arland.jpg" alt="Ernest Arland" className="formation-photo" />
          <p className="photo-caption">Ernest Arland - Circa 1964</p>
          <div className="formation-text">
            <p>Ernest Arland is featured only once in "The Snow Flowerz" entire catalog, and that is on "Don't Ask Me How," – Track 1 of The Snow Flowers debut 1967 self-titled album (aka "White Album") – released on March 21, 1967.</p>
            <p>The Snow Flowers went on to compile the life's work of Ernest Arland into a 12 song LP entitled "Ernest," which included songs that were originally intended to be featured on The Snow Flowers debut record, and on which Ernest Arland is heard being accompanied by the voices of Xavier Photano, Alpha Atari, the Hames sisters and the drumming of Jean Hubbard.</p>
            <p>The final track (Track 10) on "The Snow Flowers" (White Album) entitled "Ernest" came to feature prominent San Francisco blues musician – Gilbert C. Jackson - who aided The Snow Flowers in writing and performing the perfect tribute to the late musician. He is heard delivering a powerful vocal performance amidst an all-black church choir along with the 5 surviving members of the band, concluding the album with poignant passion and holy deliverance.</p>
          </div>
          <img src="/angelo_jackson.jpg" alt="Gilbert Jackson" className="formation-photo" />
          <p className="photo-caption">Gilbert Jackson - Circa 1966</p>
          <div className="formation-text">
            <p>The remaining 5 members of The Snow Flowers were thus catapulted to stardom upon being signed by Labyrinth Records and releasing their debut (white) album. "Unbreakable Heart" and "Queen America," were also released as singles reaching #3 and #10 in the US Hot 100 Billboard Chart.</p>
            <p>According to believers of the lore, even The Beatles were thoroughly impressed with The Snow Flowers debut, particularly on the part of John Lennon, who was deeply moved by the song "I Forgive You, John," which Natalie Hames (only 19 years old) had written in late 1966 with Lennon and his "Bigger than Jesus" controversy in mind.</p>
            <p>The Beatles eventually paid homage to The Snow Flowers by creating their own "White" self-titled album cover in 1968.</p>
          </div>
          <h3 className="formation-title">1967 Tour - Follow Up Singles</h3>
          <img src="/tour_1967.jpg" alt="1967 Tour" className="formation-photo" />
          <div className="formation-text">
            <p>Just prior to the launch of their first American tour, The Snow Flowers released "The Song That Wrote Itself" as a single on May 28, 1967, which reached #7 in the US. Though the B-Side - "Who I'm Meant to Be" - got substantial airplay as well and ended up topping out at #24.</p>
            <p>Almost a year later, on April 11, 1968, the band released their next single "The Love of Haight Street," which was very well received coming in at #3 in the US while adding significantly to the hype surrounding the band's follow up album, which was originally set to be released on July 13, 1968, but ended up being delayed until September 2, 1968.</p>
            <p>Once again, the B-Side "Armor of One" got substantial airplay as well and managed to top out at #10.</p>
          </div>
          <h3 className="formation-title">1968 World Tour - Follow Up Album: Gatekeepers of Division - Religious Controversy</h3>
          <div className="formation-text">
            <p>The band committed the summer of 1968 to their first "World Tour," with concerts in The United States, Canada, The UK, Germany, France, Japan and Australia, which solidified their presence not only as fantastic songwriters, but as cutting-edge live performers. It was also during this tour that "the holy cross" was employed as a permanent "stage prop" and aesthetic symbol of The Snow Flowers.</p>
          </div>
          <img src="/aesthetic_symbol.jpg" alt="1968 World Tour Concert - The Holy Cross" className="formation-photo" />
          <p className="photo-caption">Mayor's Festival - Seattle 1971</p>
          <div className="formation-text">
            <p>It is unclear when the band began actively experimenting with LSD, but upon the September 2, 1968 release of their follow up album entitled "Gatekeepers of Division," it became abundantly clear that they were diving headfirst into an overtly psychedelic and counter culture oriented direction, which delighted many fans, but nevertheless alienated others.</p>
            <p>"Peaceful Crusade" and "Gatekeepers of Division" (title track) were also released as singles, coming in at #12 and #10 in the US, though "Higher Than the Hands Can Hold," which was the B-Side of the title track, managed to out-perform the intended single, and topped out at #7. "I Thought I Knew What Real Was" had been the B-Side of "Peaceful Crusade," and while it too was gaining immense popularity, the track was banned from airplay for its explicit drug (LSD) related lyrics.</p>
            <p>The final track of the album "2000 Years in the Making" however came as a bit of a surprise, and while orchestral arrangments had made their way into rock music over the last couple of years (largely initiated by The Beatles), this track was an incredibly dynamic, emersive, traditional and classically beautiful orchestral piece that was composed, delivered by, and credited to - the London Symphony Orchestra - who granted the piece to The Snow Flowers as the closing installment to their "Gatekeepers of Division" album.</p>
            <p>Arranging this was in fact the reason that the album had been delayed, for it was originally Alpha Atari's idea, having maintained many musical connections from Britain, which evidently spanned beyond just rock and roll.</p>
            <p>Thus after lengthy negotiations amidst extenuating financial dealings, the track was cemented under the Snow Flowers name, which inevitably brought a rather unexpected and abruptly conservative close to the album that nevertheless seemed to lend itself pertinently (and perhaps paradoxically) to its psychedelic unpredictability.</p>
          </div>
          <img src="/gatekeepers_cover.jpg" alt="Gatekeepers of Division" className="formation-photo" />
          <p className="photo-caption">Gatekeepers of Division - 1968 Album</p>
          <div className="formation-text">
            <p>It was only shortly thereafter that The Snow Flowers found themselves to be the subjects of significant controversy as religious leaders began accusing them of heresy, particularly in regard to their use of the "holy cross," for many conservatives came to view it as a subversive mockery, rather than faithful reverence, as well as a means by which the band sought to represent and "glorify" themselves.</p>
            <p>Xavier Photano thus became infamous among religious circles after saying in a late 1968 interview that The Snow Flowers are "redeeming the holy cross," which (not unlike John Lennon's "bigger than Jesus" comment two years prior) only added fuel the fire of controversy, with many evangelicals now accusing the band of attempting to "hijack" Christianity, though Photano went on to say –</p>
            <p><em>"They are free to call us whatever they wish… but really… who is more likely to open people up to the idea of God or a higher power? Us or them?.. In my view… a lot of these zealots and leaders are actively closing people off… with their ridged and fanatical desperation… which is really just faithlessness disguised as faith."</em></p>
            <p>Thus did the band's conservative fan base dwindle significantly, yet their liberal following, and overall popularity, continued to grow exponentially as they continued fervently to innovate, push musical boundaries and become increasingly bold and ambitious with each subsequent record.</p>
          </div>
          <h3 className="formation-title">1969 Album: Metanoia's Fire - US Tour - Woodstock - Single</h3>
          <img src="/metanoias_fire_cover.png" alt="Metanoia's Fire" className="formation-photo" />
          <p className="photo-caption">Metanoia's Fire - 1969 Album</p>
          <div className="formation-text">
            <p>On June 3, 1969, The Snow Flowers released their 3rd studio album entitled "Metanoia's Fire," which sent shockwaves throughout the music industry and America's counter culture movement. For it seemed that the diversity, innovation and dynamic expressionism that came through the record was entirely unmatched, not only as result of its overtly heavy guitars and psychedelic drive, but its soulful sense of reconciliation.</p>
            <p>"Cosmic Reign/Riders of the Red Sea," "I Walked on Water/Pendulum's Edge" and "Metanoia's Fire/Into the Mystic" were released as singles, all of which performed spectacularly well, coming in at #5, #7 and #2 on the US Billboard chart.</p>
            <p>"Metanoia's Fire" (title track) featured child singer - Kate Hutchinson - accompanying Alpha Atari on vocals, who invariably provided the first non-Snow Flower vocal performance since Gilbert Jackson's central delivery of "Ernest."</p>
            <p>The band proceeded with a short tour of the United States, ending it with their legendary performance at Woodstock Music and Arts Festival in Bethel, New York on August 17, 1969. They played for nearly two hours and it was arguably the most iconic and celebrated performance of their career.</p>
          </div>
          <img src="/woodstock_1969.jpg" alt="Alpha Atari and Enya Hames at Woodstock 1969" className="formation-photo" />
          <p className="photo-caption">Alpha Atari and Enya Hames (sound check) - Woodstock 1969</p>
          <div className="formation-text">
            <p>On September 17, 1969, The Snow Flowers released their single "Body of the Unseen" (with "Folklore" as its B-Side) which didn't do quite as well as their previous singles, but certainly added to their new, more aggressive and psychedelic sound, topping out at #20 in the US.</p>
          </div>
          <h3 className="formation-title">1970 Album: Seraphym - World Tour - Marriages</h3>
          <img src="/seraphym_cover_new.jpg" alt="Seraphym" className="formation-photo" />
          <p className="photo-caption">Seraphym - 1970 Album</p>
          <div className="formation-text">
            <p>On May 22, 1970, The Snow Flowers released their 4th studio album entitled "Seraphym," which came to be known as their most psychedelic and experimental record. "Whispering Wind/Familiar" and "The Homeless Man/Celestial Alchemy" were released as singles, though once again, they didn't quite reach the same level of success as the "Metanoia's Fire" singles had, coming in at #15 and #23 in the US.</p>
            <p>The album featured previously unknown artist "Joshua Brown" on vocals for two tracks – "Shinedown," and "Beyond the Last Light," which were by far the darkest and moodiest songs the group had ever released to date. So much so in fact that "Beyond the Last Light," was subsequently banned from airplay, with many describing it as "a descent into hell."</p>
            <p>The Snow Flowers didn't release any singles in 1970, but the summer brought about yet another widely successful world tour, and with The Beatles officially disbanding, they were often considered to be the world's greatest rock band.</p>
            <p>In the fall, both couples - Xavier Photano/Natalie Hames and Alpha Atari/Enya Hames - got married in Los Angeles.</p>
          </div>
          <h3 className="formation-title">1971 Album: Enigmatic Influx - Concerts - Single Releases</h3>
          <img src="/enigmatic_influx_cover.jpg" alt="Enigmatic Influx" className="formation-photo" />
          <p className="photo-caption">Enigmatic Influx - 1971 Album</p>
          <div className="formation-text">
            <p>On July 20, 1971, The Snow Flowers released their 5th studio album entitled "Enigmatic Influx," which was the band's psychedelic hard rock album, featuring plenty of heavy guitars and energetic/aggressive vocals. "Say Goodbye to the Machine/Magnetic West," "Divine Vanity/Broken Mirror" and "You Built the Universe/White Sabbath" were released as singles and topped out at #22, #21 and #27 in the US.</p>
            <p>The band played several worldwide shows throughout 1971, though they were scattered and not classified as part of an official world tour.</p>
            <p>On Sept 2, 1971, The Snow Flowers released a new single "Silk Road" (with "A Taste of the Shore" as the B-Side) which performed well, topping out at #18 in the US.</p>
          </div>
          <h3 className="formation-title">The Attempted Assassination of Xavier Photano: September 29, 1971</h3>
          <img src="/rice_hotel_1971.jpg" alt="Xavier Photano and Natalie Hames at Rice Hotel" className="formation-photo" />
          <p className="photo-caption">Xavier Photano and Natalie Hames arrive at the Rice Hotel in Houston - September 28, 1971</p>
          <div className="formation-text">
            <p>In a disturbing turn of events, Xavier Photano was shot and nearly killed in Houston, Texas on the afternoon of September 29, 1971 as The Snow Flowers were leaving the Rice hotel to perform at the Astrodome. He was struck in the shoulder with a 150 grain Spitzer bullet from a .30-06 and immediately taken to St. Joseph's hospital where he eventually made a full recovery.</p>
            <p>The gunman was identified as 34 year old "Samuel Jacob Hartman" of Fort Worth, TX. He was immediately arrested and eventually given the death penalty.</p>
            <p>The Snow Flowers thereby took the entire year of 1972 away from the music scene, choosing to focus on family life, writing solo work and other personal and business pursuits.</p>
          </div>
          <h3 className="formation-title">Final 1973 Album: Divine Design - Disbanding - Single Release</h3>
          <img src="/divine_design_cover.jpg" alt="Divine Design" className="formation-photo" />
          <p className="photo-caption">1973 Album - Divine Design</p>
          <div className="formation-text">
            <p>April 22, 1973 brought about the release of The Snow Flowers 6th and final studio album entitled "Divine Design," which came with a very touching, focused and sophisticated version of the band with "Dreams/Lapis Lazuli," "Gentle Irony/Old House," "Divine Design/Full Circle," "A Star at the End of Time/Divine is Your Hand," and "I Don't Need Love/Ode to Mary Magdalene" all being released as singles, making this by far the most successful album of the band's career, with the 5 stated singles topping out at #17, #8, #4, #5 and #2 on the US charts.</p>
            <p>Sadly, the world anticipated the return of a promotional world tour that never came, and it was at last on July 22, 1973 that The Snow Flowers performed a final private concert at an undisclosed location (which was recorded and turned into their "Unplugged" live album) before mysteriously disappearing from the music industry forever.</p>
            <p>With one last surprise, The Snow Flowers released their last single, and final musical contribution – "By Their Fruit," with "The Fall of Conquest" as the B-Side – on October 3, 1973. Spectacularly, it reached #1 in both the US and UK, and became their only #1 hit.</p>
          </div>
          <h3 className="formation-title">Top Snow Flowers References in Music</h3>
          <div className="formation-text">
            <ol className="references-list">
              <li>Led Zeppelin - Stairway to Heaven - "The Whispering Wind" Lyric</li>
              <li>Pink Floyd - Shine on You "Crazy Diamond"</li>
              <li>The Beatles - White Album Cover</li>
              <li>Black Sabbath - Holy Cross Aesthetic</li>
              <li>Fleetwood Mac - Stevie Nicks Vocal Style</li>
              <li>Shinedown - Band Name</li>
              <li>MGMT - Andrew VanWyngarden cosplays Alpha Atari</li>
              <li>Live "Unplugged" Shows of the 90s</li>
            </ol>
          </div>
          <div className="mystical-star conclusion-star">
            <div className="star-core"></div>
            <div className="star-rays"></div>
            <div className="star-glow"></div>
            <div className="star-sparkles">
              <span></span><span></span><span></span><span></span>
              <span></span><span></span><span></span><span></span>
            </div>
          </div>
          <h3 className="featured-artists-title">In Conclusion</h3>
          <div className="formation-text">
            <p>A special thank you to - <span className="highlight-gold">Adam Alchemy</span> - Canadian artist, visionary, manager, producer and channeler of<br /><span className="highlight-band-name">The Snow Flowerz</span></p>
          </div>
          <img src="/adam_alchemy.jpg" alt="Adam Alchemy" className="formation-photo" />
          <p className="association-text">In association with</p>
          <img src="/adam_alchemy_records.jpg" alt="Adam Alchemy Records" className="formation-photo association-image" />
          <div className="formation-text">
            <p>Cheers and thank you for listening!</p>
          </div>
          <div className="conclusion-quote">
            <h2 className="conclusion-title">Remember<br />The Snow Flowers</h2>
            <p className="conclusion-subtitle">- The Snow Flowerz</p>
          </div>
          <div className="listen-now-section">
            <p className="listen-now-text">Listen Now!</p>
            <a href="https://payhip.com/adamalchemy" target="_blank" rel="noopener noreferrer" className="click-here-btn">Click Here</a>
          </div>
        </div>
      </section>

      {/* Contact Section with Holy Cross Animation */}
      <div className="mystical-star contact-star">
        <div className="star-core"></div>
        <div className="star-rays"></div>
        <div className="star-glow"></div>
        <div className="star-sparkles">
          <span></span><span></span><span></span><span></span>
          <span></span><span></span><span></span><span></span>
        </div>
      </div>

      {/* Footer */}
      <footer className="footer" id="footer">
        <div className="container">
          <p>© 2026 Adam Alchemy Records. All Rights Reserved.</p>
          <p>Contact Us - alchemyadam@gmail.com</p>
          <p><a href="/privacy-policy" className="footer-link">Privacy Policy</a></p>
        </div>
      </footer>
    </div>
  );
}

export default App;
